import { gql } from '@apollo/client'

const queryUserList = gql`
  query userList(
    $page: Float!
    $limit: Float!
    $columnName: String
    $order: String
    $search: String
    $isExport: Boolean
    $user_type: [String!]
    $balance: Boolean
  ) {
    userList(
      page: $page
      limit: $limit
      columnName: $columnName
      order: $order
      search: $search
      isExport: $isExport
      user_type: $user_type
      balance: $balance
    ) {
      users
      page
      limit
      total_records
    }
  }
`

const queryDeleteUser = gql`
  query userDelete($_id: String!) {
    userDelete(_id: $_id)
  }
`

const queryuserDashboardCounts = gql`
  query userDashboardCounts($user_id: String) {
    userDashboardCounts(user_id: $user_id) {
      _id
      spent_amount
      spent_amount_percentage
      available_balance
      available_balance_percentage
      total_campaign
      total_campaign_percentage
      live_campaign
      live_campaign_percentage
      pending_campaign
      pending_campaign_percentage
      approved_campaign
      approved_campaign_percentage
      paused_campaign
      paused_campaign_percentage
      active_campaign
      active_campaign_percentage
      total_clicks
      total_clicks_percentage
    }
  }
`

const queryuserDashboardAverageCounts = gql`
  query userDashboardAverageCounts {
    userDashboardAverageCounts {
      total_clicks
      total_clicks_percentage
      average_cpc
      average_cpc_percentage
      average_ctr
      average_ctr_percentage
      click_time
    }
  }
`

const queryAssignableUserList = gql`
  query assignableUserList($user_id: String!, $page: Float!, $limit: Float!, $search: String) {
    assignableUserList(user_id: $user_id, page: $page, limit: $limit, search: $search) {
      users
      page
      limit
      total_records
    }
  }
`

const mutationUserGoalSetup = gql`
  mutation userGoalSetUp($business_sector: String!, $main_goal: String!, $monthly_budget: String!) {
    userGoalSetUp(business_sector: $business_sector, main_goal: $main_goal, monthly_budget: $monthly_budget) {
      user_id
      business_sector
      main_goal
      monthly_budget
      recommendations {
        platform
        optional
      }
    }
  }
`

const mutationAssignUsers = gql`
  mutation assignUsers($emails: [String!]!, $user_id: String) {
    assignUsers(emails: $emails, user_id: $user_id)
  }
`

const mutationRevokeUsers = gql`
  mutation revokeUsers($email: String!, $user_id: String) {
    revokeUsers(email: $email, user_id: $user_id)
  }
`

const queryAccessUserList = gql`
  query accessUserList($page: Float!, $limit: Float!, $search: String, $user_id: String) {
    accessUserList(page: $page, limit: $limit, search: $search, user_id: $user_id) {
      users
      page
      limit
      total_records
    }
  }
`

export {
  queryUserList,
  queryDeleteUser,
  queryuserDashboardCounts,
  queryuserDashboardAverageCounts,
  queryAssignableUserList,
  mutationUserGoalSetup,
  mutationAssignUsers,
  mutationRevokeUsers,
  queryAccessUserList
}
